import { fromJS } from 'immutable';
import * as sessionActionTypes from '../actions/sessionActionTypes';
import * as sessionStateTypes from '../constants/sessionStateTypes';
import { CollectionItem } from '../utils/collectionUtils';
import { DEFAULT_COLLECTION_ID, LOCAL_STORAGE_LOCALE_KEY } from '../constants/session';
import { setDBLanguage, setDataLanguage, getLanguageFromLocale } from '../utils/piction';
import { SESSION_RELOGIN_MESSAGE } from '../constants/sessionStateTypes';

// todo: need to be able to cancel the requests

const initialState = fromJS({
  sessionState: sessionStateTypes.INITIALISED,
  sessionStateMessage: null,
  surl: null,
  username: null,
  email: null,
  loginCodeState: null,
  collectionList: [new CollectionItem(DEFAULT_COLLECTION_ID, 'Default Collection')],
  isRequestingCollections: false,
  collectionsRequest: null,
  advancedSearchCollectionList: null,
  isRequestingAdvancedSearchCollections: false,
  advancedSearchCollectionsRequest: null,
  metatags: {},
  isWorkbench: false,
  locale: 'en',
  dataLanguage: 'ENGLISH',
  token: null,
  surlCookie: false,
  acctType: false,
  userCollection: null,
  keywordDelimiter: [],
  parsedMetatags: [],
  languageList: [],
});

const session = (state = initialState, action) => {
  switch (action.type) {
    case sessionActionTypes.VALIDATE_SURL_REQUEST:
      return state
        .set('sessionState', sessionStateTypes.REQUESTING_VALIDATION)
        .set('sessionStateMessage', null)
        .set('surl', null)
        .set('username', null)
        .set('surlCookie', null)
        .set('email', null)
        .set('loginCodeState', null)
        .set('languageList', []);
    case sessionActionTypes.VALIDATE_SURL_SUCCESS:
      if (action.isValid) {
        return state
          .set('sessionState', sessionStateTypes.LOGGED_IN)
          .set('surl', action.surl)
          .set('token', action.token)
          .set('surlCookie', action.surlCookie)
          .set('username', action.username)
          .set('isWorkbench', action.isInvokeWorkbench)
          .set('userCollection', action.userCollection)
          .set('acctType', action.acctType)
          .set('locale', action.locale)
          .set('email', action.email)
          .set('loginCodeState', null)
          .set('dataLanguage', action.dataLanguage)
          .set('languageList', action.languages);
      }
      return state
        .set('sessionState', sessionStateTypes.LOGIN_REQUIRED)
        .set('sessionStateMessage', new Error(sessionStateTypes.SESSION_RELOGIN_MESSAGE))
        .set('surl', null)
        .set('username', null)
        .set('token', null)
        .set('surlCookie', null)
        .set('email', null)
        .set('loginCodeState', null)
        .set('languageList', []);
    case sessionActionTypes.VALIDATE_SURL_FAILURE:
      return state
        .set('sessionState', sessionStateTypes.LOGIN_REQUIRED)
        .set('sessionStateMessage', null)
        .set('surl', null)
        .set('username', null)
        .set('token', null)
        .set('surlCookie', null)
        .set('email', null)
        .set('loginCodeState', null)
        .set('languageList', []);
    case sessionActionTypes.SESSION_EXPIRED:
      return state
        .set('sessionState', sessionStateTypes.SESSION_TIMEOUT)
        .set('sessionStateMessage', new Error(sessionStateTypes.SESSION_RELOGIN_MESSAGE))
        .set('surl', null)
        .set('username', null)
        .set('token', null)
        .set('surlCookie', null)
        .set('email', null)
        .set('loginCodeState', null)
        .set('languageList', []);
    case sessionActionTypes.VALIDATE_SESSION_CONNECTION_REQUEST:
      return state
        .set('sessionState', sessionStateTypes.REQUESTING_SESSION_VALIDATION);
    case sessionActionTypes.VALIDATE_SESSION_CONNECTION_SUCCESS:
      return state
        .set('sessionState', sessionStateTypes.LOGGED_IN);
    case sessionActionTypes.VALIDATE_SESSION_CONNECTION_FAILURE:
      return state
        .set('sessionState', sessionStateTypes.SESSION_TIMEOUT)
        .set('sessionStateMessage', new Error(sessionStateTypes.SESSION_RELOGIN_MESSAGE))
        .set('surl', null)
        .set('username', null)
        .set('token', null)
        .set('surlCookie', null)
        .set('email', null)
        .set('loginCodeState', null)
        .set('languageList', []);
    case sessionActionTypes.LOGIN_REQUEST:
      return state
        .set('sessionState', sessionStateTypes.REQUESTING_LOGIN)
        .set('sessionStateMessage', null)
        .set('surl', null)
        .set('username', null)
        .set('token', null)
        .set('surlCookie', null)
        .set('email', null)
        .set('loginCodeState', null)
        .set('languageList', []);
    case sessionActionTypes.LOGIN_SUCCESS:
      return state
        .set('sessionState', sessionStateTypes.LOGGED_IN)
        .set('sessionStateMessage', null)
        .set('surl', action.surl)
        .set('username', action.username)
        .set('token', action.token)
        .set('isWorkbench', action.isInvokeWorkbench)
        .set('userCollection', action.userCollection)
        .set('surlCookie', action.surlCookie)
        .set('acctType', action.acctType)
        .set('locale', action.locale)
        .set('email', action.email)
        .set('loginCodeState', null)
        .set('dataLanguage', action.dataLanguage)
        .set('languageList', action.languages);
    case sessionActionTypes.LOGIN_FAILURE:
      return state
        .set('sessionState', sessionStateTypes.LOGIN_REQUIRED)
        .set('sessionStateMessage', action.err)
        .set('surl', null)
        .set('username', null)
        .set('token', null)
        .set('surlCookie', null)
        .set('email', null)
        .set('loginCodeState', null)
        .set('languageList', []);
    case sessionActionTypes.LOGIN_CODE_REQUIRED:
      return state
        .set('sessionState', sessionStateTypes.LOGIN_CODE_REQUIRED)
        .set('sessionStateMessage', sessionStateTypes.SESSION_CODE_REQUIRED_MESSAGE)
        .set('username', action.username)
        .set('loginCodeState', action.code);
    case sessionActionTypes.LOGIN_CODE_REQUEST:
      return state
        .set('sessionState', sessionStateTypes.REQUESTING_LOGIN_CODE);
    case sessionActionTypes.LOGIN_CODE_SUCCESS:
      return state
        .set('sessionState', sessionStateTypes.LOGGED_IN)
        .set('sessionStateMessage', null)
        .set('token', action.token)
        .set('surl', action.surl)
        .set('isWorkbench', action.isInvokeWorkbench)
        .set('userCollection', action.userCollection)
        .set('surlCookie', action.surlCookie)
        .set('acctType', action.acctType)
        .set('locale', action.locale)
        .set('email', action.email)
        .set('loginCodeState', null)
        .set('dataLanguage', action.dataLanguage)
        .set('languageList', action.languages);
    case sessionActionTypes.LOGIN_CODE_FAILURE:
      return state
        .set('sessionState', sessionStateTypes.LOGIN_REQUIRED)
        .set('sessionStateMessage', action.err)
        .set('surl', null)
        .set('username', null)
        .set('token', null)
        .set('surlCookie', null)
        .set('email', null)
        .set('loginCodeState', null);
    case sessionActionTypes.LOGIN_CODE_RELOGIN:
      return state
        .set('sessionState', sessionStateTypes.LOGGED_OUT)
        .set('sessionStateMessage', { message: sessionStateTypes.SESSION_RELOGIN_MESSAGE });
    case sessionActionTypes.LOGOUT_REQUEST:
      return state
        .set('sessionState', sessionStateTypes.REQUESTING_LOGOUT)
        .set('sessionStateMessage', null);
    case sessionActionTypes.LOGOUT_SUCCESS:
      return state
        .set('sessionState', sessionStateTypes.LOGGED_OUT)
        .set('sessionStateMessage', null)
        .set('surl', null)
        .set('username', null)
        .set('token', null)
        .set('surlCookie', null)
        .set('email', null)
        .set('loginCodeState', null)
        .set('languageList', []);
    case sessionActionTypes.LOGOUT_FAILURE:
      return state
        .set('sessionState', sessionStateTypes.LOGGED_OUT)
        .set('sessionStateMessage', action.err)
        .set('surl', null)
        .set('username', null)
        .set('token', null)
        .set('surlCookie', null)
        .set('email', null)
        .set('loginCodeState', null)
        .set('languageList', []);
    case sessionActionTypes.RETRIEVE_COLLECTIONS_REQUEST:
      return state
        .set('isRequestingCollections', true)
        .set('collectionsRequest', action.requestPromise);
    case sessionActionTypes.RETRIEVE_COLLECTIONS_SUCCESS:
      return state
        .set(
          'collectionList',
          fromJS([state.getIn(['collectionList', 0]), ...action.collectionList]),
        )
        .set('isRequestingCollections', false)
        .set('collectionsRequest', null);
    case sessionActionTypes.RETRIEVE_COLLECTIONS_FAILURE:
      return state
        .set('isRequestingCollections', false)
        .set('collectionsRequest', action.err);
    case sessionActionTypes.RETRIEVE_ADVANCED_SEARCH_COLLECTIONS_REQUEST:
      return state
        .set('isRequestingAdvancedSearchCollections', true)
        .set('advancedSearchCollectionsRequest', action.requestPromise);
    case sessionActionTypes.RETRIEVE_ADVANCED_SEARCH_COLLECTIONS_SUCCESS:
      return state
        .set('advancedSearchCollectionList', fromJS(action.advancedSearchCollectionList))
        .set('isRequestingAdvancedSearchCollections', false)
        .set('advancedSearchCollectionsRequest', null);
    case sessionActionTypes.RETRIEVE_ADVANCED_SEARCH_COLLECTIONS_FAILURE:
      return state
        .set('isRequestingAdvancedSearchCollections', false)
        .set('advancedSearchCollectionsRequest', action.err);
    case sessionActionTypes.RETRIEVE_METATAGS_REQUEST:
      return state
        .mergeDeep({ metatags: { [action.collectionID]: action.requestPromise } });
    case sessionActionTypes.RETRIEVE_METATAGS_SUCCESS: {
      // gets id's of html/rich text metatags- so they would be parsed on display
      if (action.collectionID !== DEFAULT_COLLECTION_ID) {
        const parseTags = Array.isArray(state.get('parsedMetatags')) ? state.get('parsedMetatags')
          : state.get('parsedMetatags').toJS();
        const keywordTags = Array.isArray(state.get('keywordDelimiter')) ? state.get('keywordDelimiter')
          : state.get('keywordDelimiter').toJS();
        action.metatagList.forEach((i) => {
          if (((i.DISPLAY_API[0] && i.DISPLAY_API[0].toUpperCase().includes('RICH'))
            || (i.TYPE[0] && i.TYPE[0].toUpperCase().includes('HTML'))
            || (i.KEYWORD_ANCHOR && i.KEYWORD_ANCHOR[0] === 'W')) && !parseTags.includes(i.$.TAG_ID)) {
            parseTags.push(i.$.TAG_ID);
          }
          // TODO: filtering every time could be a little costly
          if (i.RFIELD_DELIMETER[0] !== '' && !keywordTags.some((e) => e.id === i.$.TAG_ID)) {
            keywordTags.push({ id: i.$.TAG_ID, delimeter: i.RFIELD_DELIMETER[0] });
          }
        });

        return state
          .set('parsedMetatags', parseTags)
          .set('keywordDelimiter', keywordTags)
          .mergeDeep({ metatags: { [action.collectionID]: action.metatagList } });
      }

      return state
        .mergeDeep({ metatags: { [action.collectionID]: action.metatagList } });
    }
    case sessionActionTypes.RETRIEVE_METATAGS_FAILURE:
      return state
        .mergeDeep({ metatags: { [action.collectionID]: action.err } });
    case sessionActionTypes.CHANGE_LOCALE:
      setDBLanguage(action.locale);
      sessionStorage.setItem(LOCAL_STORAGE_LOCALE_KEY, action.locale);
      return state
        .set('locale', action.locale);
    case sessionActionTypes.CHANGE_DATA_LANGUAGE:
      setDataLanguage(action.selectedLanguage);
      return state.set('dataLanguage', action.selectedLanguage);
    case sessionActionTypes.UPDATE_DEFAULT_COLLECTION_LABEL: {
      const indexOfDefaultCollection = state.get('collectionList').findIndex((item) => item.get('id') === DEFAULT_COLLECTION_ID);

      if (indexOfDefaultCollection > -1) {
        return state.setIn(['collectionList', indexOfDefaultCollection, 'name'], action.label);
      }
      return state;
    }
    default:
      return state;
  }
};

export default session;
